import styled from 'styled-components';

export const HeaderContentWrapper = styled.div<{
  limitHeaderContentWidth: boolean;
}>`
  display: flex;
  flex-direction: row;
  width: ${({ limitHeaderContentWidth }) =>
    limitHeaderContentWidth ? `calc(100% - 90px)` : `100%`};
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: block;
  max-width: calc(100% - 32px - 16px);
  h5,
  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
